module.exports = __webpack_public_path__ + "img/05.2f3cfa26.png";